import { useLang } from "../i18n";
import { CASHIER_DOWNLOAD_URL } from "../content/contacts";

export function Footer() {
  const { t, lang } = useLang();
  const deckHref = lang === "kk" ? "/landing/deck/kz/index.html" : "/landing/deck/index.html";

  return (
    <footer
      className="border-t px-5 py-10 sm:px-8"
      style={{
        borderColor: "var(--line)",
        background: "var(--bg-deep)",
        color: "var(--fg-muted)",
      }}
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-3 sm:flex-row">
        <span className="t-brand text-xs tracking-wide" style={{ color: "var(--fg-soft)" }}>
          ORDA<span style={{ color: "var(--gold)" }}>&nbsp;OS</span>
        </span>
        <span className="text-xs font-semibold uppercase tracking-[0.16em]">
          {t.footer.copyright}
        </span>
        <div className="flex items-center gap-3 text-xs">
          <a
            href={deckHref}
            target="_blank"
            rel="noopener"
            className="hover:opacity-80"
            style={{ color: "var(--gold)" }}
          >
            {t.nav.deck}
          </a>
          <span style={{ color: "var(--line)" }}>·</span>
          {/* Ссылка ведёт на редирект к .exe последнего релиза кассы */}
          <a
            href={CASHIER_DOWNLOAD_URL}
            className="hover:opacity-80"
            style={{ color: "var(--gold)" }}
          >
            {t.footer.download}
          </a>
          <span style={{ color: "var(--line)" }}>·</span>
          <a href="/landing/privacy" className="hover:opacity-80" style={{ color: "var(--fg-muted)" }}>
            {t.footer.privacy}
          </a>
          <span style={{ color: "var(--line)" }}>·</span>
          <a href="/landing/terms" className="hover:opacity-80" style={{ color: "var(--fg-muted)" }}>
            {t.footer.terms}
          </a>
        </div>
        <span className="text-xs">{t.footer.tagline}</span>
      </div>
    </footer>
  );
}
